import { ApolloQueryResult } from 'apollo-client';

import { dialogsQuery } from '../../graphql/queries/grid/dialogs';
import { DialogsQuery, DialogsQuery_client_dialogs } from '../../typings/graphql-grid';
import { BaseDataProvider } from '../BaseDataProvider/BaseDataProvider';

export type DialogsApiDataResult = (DialogsQuery_client_dialogs | null)[];

export class DialogsDataProvider extends BaseDataProvider {
    public getDialogs = (login: string): Promise<DialogsApiDataResult> => {
        return this.createQuery<DialogsQuery>(dialogsQuery, {
            variables: {
                login
            }
        }).then((result: ApolloQueryResult<DialogsQuery>) => {
            return result.data.client.dialogs;
        });
    };
}
